import { getRxEntryType } from "../../../../../../../utils/modules/EcommContent/ContactLensesEcommContent/utils/get-rx-entry-type.js";
import { getMaxSelectableQuantity } from "../../../../../../../utils/modules/EcommContent/ContactLensesEcommContent/utils/get-max-selectable-quantity.js";
import { WITHOUT_RX, WITH_RX } from "../../../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/contants.js";
const getInitialState = ({
  purchaseType,
  sortedAttributesSet,
  maxOrderableQuantity,
  defaultDeliveryInterval
}) => {
  const maxSelectableQuantity = getMaxSelectableQuantity({
    allowBackOrder: true,
    maxOrderableQuantity
  });
  const rxAttributeDefaults = sortedAttributesSet.reduce(
    (acc, { name, attributeOptions }) => {
      if (Object.keys(attributeOptions).length === 1) {
        return {
          ...acc,
          [name]: Object.values(attributeOptions)[0]
        };
      }
      return {
        ...acc,
        [name]: null
      };
    },
    {}
  );
  const rxEntryType = getRxEntryType(sortedAttributesSet);
  const rxToggle = rxEntryType === "no-rx-entry" ? WITHOUT_RX : WITH_RX;
  const columnConfigurationsDefaults = {
    prescription: rxAttributeDefaults,
    quantity: 1
  };
  const columnUIDefaults = {
    isEnabled: true,
    quantitySelector: {
      maxSelectableQuantity,
      selectionInvalidatedCount: void 0
    }
  };
  return {
    configurations: {
      purchaseType,
      rxToggle,
      left: columnConfigurationsDefaults,
      right: columnConfigurationsDefaults,
      both: columnConfigurationsDefaults,
      subscriptionPurchaseConfigurations: {
        deliveryInterval: defaultDeliveryInterval ?? null
      }
    },
    queries: {
      left: {
        sku: void 0
      },
      right: {
        sku: void 0
      },
      both: {
        sku: void 0
      }
    },
    configurator: {
      rxEntryType,
      invalidSubmissionsCount: void 0,
      left: columnUIDefaults,
      right: columnUIDefaults,
      both: columnUIDefaults,
      columns: {
        showError: false
      },
      columnCheckboxes: {
        showError: false
      },
      deliveryInterval: {
        showError: false
      }
    }
  };
};
export {
  getInitialState
};
//# sourceMappingURL=get-initial-state.js.map
